<script>
  import { onMount } from "svelte";
  import { navigate } from "svelte-navigator";
  import {
    DataTable,
    Checkbox,
    Pagination,
  } from "carbon-components-svelte";
  import { TextInput, SectionWrapper } from "paxray-components-svelte";

  import { userStores } from "@stores/index.js";
  import { UserService } from "@services/index.js";
  import { settingStores } from "@stores/settingStores.js";

  import GroupCell from "./components/GroupCell.svelte";
  import EditIcon from "./svg/EditIcon.svelte";
  import SearchInput from "./components/SearchInput.svelte";
  import Modal from "../../../lib/components/Modal.svelte";
  import MultiSelect from "../../../lib/components/MultiSelect.svelte";

  import Header from "../../../lib/components/Header.svelte";
  import Button from "../../../lib/components/Button.svelte";

  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import { fly } from "svelte/transition";

  export let embedded = false;

  let headers = [
    { key: "text", value: "Name" },
    { key: "users", value: "Users" },
    { key: "actions", value: "Actions" },
  ];
  let users = [];

  let deleteGroupModalOpen = false;
  let createGroupModalOpen = false;
  let groupName = "";
  let deleteUserObj = "";
  let searchGroup = undefined;
  let groupid = null;
  let groups = [];
  let userRole = null;
  let userids = [];
  let deleteGroupInput = "";
  let description = "";
  let adduser = false;
  let deleteuser = false;
  let edituser = false;
  let deletegroup = false;
  let editgroup = false;
  let addproject = false;
  let addpersonalproject = false;
  let permissionsGroup;
  let page = 1;
  let pageSize = 10;

  $: ({ permissions, groups, users } = $settingStores);
  const { getAvailableValues, getGroups, addGroup, updateGroup, removeGroup } =
    settingStores;

  $: usersToShow = users?.map((user) => {
    return { id: user.id, text: user.username };
  });
  $: filteredGroups = searchGroup || groups || [];
  $: visibleGroups = filteredGroups.slice((page - 1) * pageSize, page * pageSize);

  $: if (!permissions || permissions.length === 0) {
    getAvailableValues();
  }

  const userService = new UserService();
  async function setUserInstore() {
    userService
      .getLoggedInUser()
      .then((user) => {
        if (user && user?.id) {
          userStores.set(user);
          checkPermissions(user);
        }
      })
      .catch((error) => {
        session.invalidate();
      });
  }

  const onRemove = (row, cell) => {
    deleteUserObj = row;
    deleteGroupModalOpen = true;
  };

  const onGroupEdit = (row, cell, group) => {
    console.log("onGroupEdit", row, cell, group);
  };

  const onSearch = (value) => {
    page = 1;
    if (groups && value.detail) {
      const searchTerm = value.detail.toLowerCase();
      const filteredGroups = groups.filter((group) => {
        return (
          (group.text && group.text.toLowerCase().includes(searchTerm)) ||
          (group.users &&
            group.users.some(
              (user) =>
                user.name && user.name.toLowerCase().includes(searchTerm),
            ))
        );
      });
      searchGroup = filteredGroups;
    } else {
      searchGroup = undefined;
    }
  };
  async function checkPermissions(user) {
    if (user?.role === "admin") return;
    let userPermissions = new Set();
    user.groups
      ?.map((group) => group.permissions)
      .forEach((perms) => {
        perms.forEach((p) => userPermissions.add(p));
      });
    userPermissions = Array.from(userPermissions);

    if (user && userPermissions.length === 0) navigate("/app");
    else if (user && !userPermissions.includes("manage_groups"))
      navigate("/app/settings");
  }

  const confirmDeleteGroup = () => {
    fetchWithSession(
      `/api/authentication/settings/groups/${deleteUserObj?.id}`,
      {
        method: "DELETE",
      },
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.ok) {
          if (deleteUserObj.users.find((u) => u.id === $userStores.id)) {
            setUserInstore();
          }
          removeGroup(deleteUserObj?.id);
        }
        deleteGroupModalOpen = false;
      });
  };

  const createGroup = () => {
    if (!groupName) return;
    fetchWithSession("/api/authentication/settings/groups", {
      method: "POST",
      body: JSON.stringify({
        name: groupName,
        users: userids,
        permissions: permissions
          .filter((permission) => permission.checked)
          .map((permission) => permission.id),
        description,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        createGroupModalOpen = false;
        if (data.ok) {
          addGroup({
            ...data.data,
            text: data.data.name,
            users: data.data.users.map((u) => ({ id: u.id, name: u.username })),
          });
          if (data.data.users.find((u) => u.id === $userStores.id)) {
            setUserInstore();
          }
        }
      });
  };

  async function saveGroup() {
    if (!groupName) return;
    await fetchWithSession(`/api/authentication/settings/groups/${groupid}`, {
      method: "PATCH",
      body: JSON.stringify({
        name: groupName,
        description,
        permissions: permissions
          .filter((permission) => permission.checked)
          .map((permission) => permission.id),
        users: userids,
      }),
    })
      .then((response) => response.json())
      .then((data) => {

        if (data.ok) {
          if (
            data.data.users.find((u) => u.id === $userStores.id) ||
            groups
              .find((g) => g.id === groupid)
              ?.users.find((u) => u.id === $userStores.id)
          ) {
            setUserInstore();
          }
          updateGroup({
            ...data.data,
            text: data.data.name,
            users: data.data.users.map((u) => ({ id: u.id, name: u.username })),
          });
        }
        createGroupModalOpen = false;
      });
  }

  const fetchGroups = () => {
    fetchWithSession(`/api/authentication/settings/groups`)
      .then((response) => response.json())
      .then((data) => {
        groups = data.data.map((d) => {
          return {
            ...d,
            users: d.users.map((u) => {
              return { id: u.id, name: u.username };
            }),
            nUsers: d?.users?.length || 0,
          };
        });
        users = data.available_users.map((d) => {
          return { id: d.id, text: d.username };
        });
      });
  };

  const handleOpenEditModal = (row) => {
    groupName = row.text;
    groupid = row.id;
    userids = row.users.map((d) => d.id);
    description = row.description;
    adduser = row.adduser;
    deleteuser = row.deleteuser;
    edituser = row.edituser;
    deletegroup = row.deletegroup;
    editgroup = row.editgroup;
    addproject = row.addproject;
    permissionsGroup = permissions;
    permissions.forEach((permission) => {
      permission.checked = row.permissions.some((p) => p.id === permission.id);
    });
    // addpersonalproject = row.addpersonalproject;

    createGroupModalOpen = true;
  };

  const handleOpenCreateModal = () => {
    userRole = "";
    userids = [];
    groupName = "";
    description = "";
    adduser = false;
    deleteuser = false;
    edituser = false;
    deletegroup = false;
    editgroup = false;
    addproject = false;
    // addpersonalproject = false;
    groupid = null;
    createGroupModalOpen = true;
    permissions.forEach((permission) => {
      permission.checked = false;
    });
  };

  onMount(() => {
    if (!groups || groups.length === 0 || !groups[0]?.users) getGroups();
  });
</script>

{#if !embedded}
  <Header section="Permission Management" area="Settings" areaHref="/app/settings/" breadcrumb="Permission Management">
    <SearchInput placeholder="Search permission groups..." on:search={onSearch} />
    <Button on:click={() => handleOpenCreateModal()} variant="secondary" iconLeft={true} setting={true} text="Add Group" icon="plus" />
  </Header>
{/if}

<SectionWrapper fullscreen shrinkContent {embedded}>
<section slot="main">
  {#if embedded}
    <div class="embedded-toolbar"><SearchInput placeholder="Search permission groups..." on:search={onSearch} /><Button on:click={() => handleOpenCreateModal()} variant="secondary" iconLeft={true} setting={true} text="Add Group" icon="plus" /></div>
  {/if}
  <div>
    {#if groups.length}
      <DataTable
        {headers}
        rows={visibleGroups}
        class="custom-table"
      >
        <svelte:fragment slot="cell" let:row let:cell>
          {#if cell.key === "users"}
            <GroupCell {row} {cell} {onGroupEdit} />
          {:else if cell.key === "actions"}
            <div class="actions-cell">
              <button on:click={() => handleOpenEditModal(row)} class="edit-remove-btn"><EditIcon /></button>
              <button on:click={() => onRemove(row, cell)} class="edit-remove-btn"><img src="/img/ui_icons/delete_forever.svg" alt="Delete" /></button>
            </div>
          {:else}
            {cell?.value || "-"}
          {/if}
        </svelte:fragment>
      </DataTable>
      <Pagination bind:page bind:pageSize totalItems={filteredGroups.length} pageSizes={[10, 25, 50]} />
    {/if}
  </div>
</section>
</SectionWrapper>


<Modal
  actions
  preventCloseOnClickOutside
  size="lg"
  bind:open={deleteGroupModalOpen}
  modalHeading={`Delete Group ${deleteUserObj?.text}`}
  primaryButtonText="Delete"
  primaryButtonAction={confirmDeleteGroup}
  autowidth
  on:close={() => (deleteGroupInput = "")}
>
  <div class="deleteModalBody">
    Are you sure you want to delete the group: <span class="group-name"
      >{deleteUserObj?.text}</span
    >?
    <br />
    <span>This action cannot be undone.</span>
  </div>
</Modal>

<Modal
  size="sm"
  preventCloseOnClickOutside
  bind:open={createGroupModalOpen}
  modalHeading={groupid ? `Edit Group:${groupName}` : "Create Group"}
  actions
  autowidth
  primaryButtonText={groupid ? "Save" : "Create Group"}
  primaryButtonAction={groupid ? saveGroup : createGroup}
  primaryButtonNotAllow={!groupName}
>
  <div>
    <TextInput
      labelText="Group name"
      bind:value={groupName}
      invalid={!groupName}
      invalidText="Please add a name."
    />
    <!-- <TextArea labelText="Description" bind:value={description} /> -->
    <br />
    {#key groupid}
      {#each permissions as permission}
        <Checkbox
          bind:checked={permission.checked}
          labelText={permission.name}
        />
      {/each}
    {/key}
    <MultiSelect
      bind:selectedIds={userids}
      items={usersToShow}
      labelText="User(s)"
      label="User"
    />
  </div>
</Modal>

<style>
  section {
    width: 100%;
  }
  .embedded-toolbar { display: flex; align-items: center; width: 100%; gap: var(--control-gap); margin-bottom: var(--control-gap) !important; }
  .embedded-toolbar :global(.search-input) { flex: 1; min-width: 0; border-color: var(--pax-black); }
  .edit-remove-btn {
    background: var(--pax-black);
    width: 30px;
    height: 30px;
    border-radius: 4px;
    display: grid;
    place-items: center;
  }
  .actions-cell { display: flex; align-items: center; gap: 0.35rem; }
  .actions-cell img { width: 15px; height: 15px; }
  :global(.custom-table th:last-child),
  :global(.custom-table td:last-child) { width: 1%; white-space: nowrap; text-align: left; }
  :global(.cross-plus-icon) {
    rotate: 45deg;
  }
  .deleteModalBody {
    padding: 23px 0px 23px 0px;
    font-family: Inter;
    font-size: 14px;
  }
  .deleteModalBody span {
    font-weight: 700;
  }
  .deleteModalBody :last-child {
    color: var(--pax-orange);
  }
</style>
